<template>
  <div class="not-found-view">
    <h1>404 - Not found</h1>
    <br /><br /><br />
    <p>The requested route does not exist.</p>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style lang="scss">
.not-found-view {
  @include flex-center();
  flex-direction: column;
}
</style>
